const RIGHT_ALIGNED_TYPES = [
  'integer', 'decimal', 'percentage', 'formula', 'lookup', 'datasheet_filter'
]

const DROP_COLUMN_TYPES = ['cascade_drop', 'conditional_cascade_drop', 'drop', 'multiple_drop']

// eslint-disable-next-line import/prefer-default-export
export { RIGHT_ALIGNED_TYPES, DROP_COLUMN_TYPES }
